import VueCompositionAPI, { computed, reactive } from '@vue/composition-api'
import Vue from 'vue'
Vue.use(VueCompositionAPI)

const state = reactive({
	language: 'en',
	subject: '',
	title: '',
})

const getLanguage = computed(() => state.language)
const getSubject = computed(() => state.subject)
const getTitle = computed(() => state.title)

const setLanguage = ({ language }) => {
	state.language = language
}

const setSubject = ({ subject }) => {
	state.subject = subject.trim()
}

const setTitle = ({ title }) => {
	state.title = title.trim()
}

const loadLanguage = language => {
	setLanguage({ language })
}

const loadSubject = subject => {
	setSubject({ subject })
}

const loadTitle = title => {
	setTitle({ title })
}

const emailSettings = {
	getLanguage,
	getSubject,
	getTitle,
	loadLanguage,
	loadSubject,
	loadTitle,
}

export default emailSettings
